<template>
  <div>
    <Loading instruction="Preparing redirect to Nedbank. Please wait..." />
  </div>
</template>

<script>
import { formMixin } from '@/mixins/formMixin.js'
import { mapState, mapActions } from 'vuex'
import axios from '@/wrapper'
import Loading from '@/components/Loading.vue'
import EventBus from '@/EventBus'

export default {
  name: 'NedbankPayBankForm',
  components: { Loading },
  mixins: [formMixin],
  data() {
    return {
      mayProceed: true,
    }
  },
  computed: {
    ...mapState('transaction', ['transaction']),
    ...mapState('signalRMessage', ['message']),
  },
  async created() {
    EventBus.$emit('toggle-progress-bar-display', false)
    await this.initiateNedbankDirect()
  },
  methods: {
    ...mapActions('signalRMessage', ['setRequest']),
    async initiateNedbankDirect() {
      this.isLoading = true
      let errorMessage = ''
      this.$emit('closeErrorMessage')

      const transactionId = this.transaction.id
      await axios
        .get(`bankApi/nedbankPay/initiate/${transactionId}`)
        .then(function (response) {
          if (response.data.HasErrors) {
            errorMessage =
              response.data.ErrorMessages[0].ErrorMessage ??
              'Login failed. Please try again.'
          }
        })
        .catch(() => {
          /* TODO: add error handling here */
        })

      if (errorMessage !== '') {
        this.$emit('setError', errorMessage)
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
